import "./CasasEco.css";
import { useEffect } from "react";

export default function CasasEco() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div class="imgSuperior">
        <p>Construcción casas ecológicas</p>
      </div>
      <div class="projectsSpace">
        <div className="casasTerminadas">
          <h3>CASAS DE DISEÑO Y RÚSTICAS RESPETUOSAS. </h3>

          <div class="proyectoCasas">
            <div class="casasImg1"></div>
          </div>
          <div class="proyectoCasas">
            <div class="casasImg2"></div>
          </div>
          <p>
            Los proyectos que llevamos a cabo, son totalmente personalizados y
            exclusivos, mediante este sistema de construcción, no hay límites a
            la hora de diseñar su nuevo hogar, usted nos propone sus ideas y
            nosotros nos encargamos de hacerla realidad. Contamos con un equipo
            de arquitectos, ingenieros y diseñadores que le acompañarán durante
            todo el proceso, para ayudarle, aconsejarle y darle respuesta a sus
            necesidades. Nuestros presupuestos son llaves en mano incluyendo
            todo tipo de equipamientos (horno, placa inducción, sanitarios,
            griferías …) y acabados según memoria de calidades que se entrega
            junto con presupuesto. Cualquier cambio propuesto por el cliente
            para nosotros no es un problema, es un desafío al que llegar para
            poder entregarle su nueva vivienda eficiente energéticamente,
            respetuosa con el medio ambiente y con todo lujo de acabados.
          </p>
        </div>
        <div class="sistema-Constructivo">
          <h3>ESTRUCTURA DE ACERO GALVANIZADO. </h3>
          <div class="casasImg3"></div>
          <p>
            El sistema constructivo que llevamos a cabo para la construcción de
            viviendas unifamiliares aisladas, está formado principalmente por
            una estructura de acero galvanizado reciclado, se fabrica
            exclusivamente para cada cliente y adaptándose a la perfección al
            diseño y requisitos deseados. Dicha estructura, una vez finalizado
            su montaje, conformará el esqueleto de la vivienda. El posterior
            aplacado exterior en la totalidad de la estructura mediante varias
            capas de material técnico y aislamientos ( tablero OSB, sistema
            sate, revestimientos ... ) que junto a la cimentación realizada en
            los trabajos iniciales, conformará el cálido, confortable y robusto
            cuerpo para nuestra nueva vivienda. El sellado del perímetro
            interior, se realiza mediante trasdosados de PYL o Drywall,
            colocando más material aislante entre la parte exterior y ésta
            interior. El resultado obtenido de todas estas capas, se traduce en
            certificaciones energética del más alto nivel, como es la de tipo A
            o incluso pudiendo llegar a certificaciones de Passive house.
          </p>
        </div>
        <div class="sistema-Constructivo">
          <h3>MEJORAS SEGÚN PRESUPUESTO INICIAL. </h3>
          <div class="casasImg4"></div>
          <p>
            Ofrecemos todo tipo de mejoras constructivas en su vivienda para
            conseguir un confort interior superior. En fase de cimentación, la
            formación de un forjado sanitario a base de casetones prefabricados
            garantiza un excelente asilamiento a la vivienda al no contactar con
            el subsuelo y poder conducir la red de saneamiento por la cámara que
            forman estos los casetones. En instalaciones incluimos en
            presupuesto inicial el sistema Aerotermia para ACS combinándolo si
            lo desea junto la climatización mediante bomba de calor por
            conductos, suelo radiante o radiadores. Las placas fotovoltaicas
            también está a la orden del día y nosotros procedemos a su
            instalación garantizando un ahorro en la factura eléctrica, dejando
            amortizada a medio plazo dicha instalación. No ponemos límite a la
            hora de proporcionar soluciones a las necesidades de nuestros
            clientes más exigentes.
          </p>
        </div>
      </div>
    </>
  );
}
